import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const InputCounter = function InputCounter(props) {
    const {
        currentCount, maximumCount,
    } = props;

    return (
        <div className={styles.counter}>
            <span>{currentCount}</span>
            <span>{`/ ${maximumCount}`}</span>
        </div>
    );
};

InputCounter.propTypes = {
    currentCount: PropTypes.number.isRequired,
    maximumCount: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
};

InputCounter.defaultProps = {
};

export default InputCounter;
